import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from '@piconetworks/pkg-link';
import style from './NavLinkItem.module.scss.js';

var _excluded = ["active", "children", "className", "disabled", "href", "LinkComponent", "onClick", "preset", "variant"];
var NavLinkItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavLinkItem, _Component);
  function NavLinkItem() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = NavLinkItem.prototype;
  _proto.render = function render() {
    var _cx;
    var _this$props = this.props,
      active = _this$props.active,
      children = _this$props.children,
      className = _this$props.className,
      disabled = _this$props.disabled,
      href = _this$props.href,
      LinkComponent = _this$props.LinkComponent,
      onClick = _this$props.onClick,
      preset = _this$props.preset;
      _this$props.variant;
      var args = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var linkBehavior = {};
    if (onClick) {
      linkBehavior.onClick = onClick;
    } else if (href) {
      linkBehavior.href = href;
    }
    return /*#__PURE__*/React.createElement(LinkComponent, _extends({}, linkBehavior, {
      className: cx(style.navLinkItem, (_cx = {}, _cx[style.active] = active, _cx[style.disabled] = disabled, _cx), className),
      preset: preset
    }, args), children);
  };
  return NavLinkItem;
}(Component);
NavLinkItem.propTypes = {
  /** Whether the link appears active */
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  LinkComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onClick: PropTypes.func,
  preset: PropTypes.string,
  variant: PropTypes.string
};
NavLinkItem.defaultProps = {
  LinkComponent: Link,
  preset: 'default'
};

export { NavLinkItem as default };
//# sourceMappingURL=NavLinkItem.js.map
